
import React from 'react';
import WirelessAccessPointsLink from '../WirelessAccessPointsLink';
const Network = () => {
  const specialCharacters =
    "!\", #, $, %, &, ', (, ), *, +, ,, -, ., /, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, :, ;, <, =, >, ?, @, A, B, C, D, E, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z, [, \\, ], ^, _, `, a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z, {, |, }, ~";
  return (
    <section id="wireless" className="content-section">
      <div className="card mb-3">
        <div className="card-body text-center">
          <h5 className="card-title">Wireless</h5>
        </div>
        <div className="card-body">
          <div className="card pt-2">
            <ol className="list-styled">
              <div>
                <div className="fw-bold">Wireless</div>

                <p className="justified-text">
                  Permite definir o comportamento do equipamento nas redes sem
                  fio.
                </p>

                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/wireless-principal.png"
                    className="card-img-bottom img-lg img-xl"
                    alt=""
                  />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      Ao clicar em{" "}
                      <i className="fa fa-trash" aria-hidden="true"></i>{" "}
                      Excluir, é possível remover redes wireless cadastradas
                      previamente.
                    </p>

                    <p className="justified-text">
                      Ao clicar em{" "}
                      <i className="fa fa-plus-circle" aria-hidden="true"></i>{" "}
                      Adicionar ou em{" "}
                      <i className="fa fa-pencil" aria-hidden="true"></i>{" "}
                      Editar, é possível cadastrar ou editar uma rede wireless
                      pela seguinte tela:
                    </p>

                    {/* <p className="justified-text">
        <strong>Obs.: </strong>Não é possível excluir a rede padrão do dispositivo, apenas desabilita-la.
      </p> */}

                    <br />

                    <div className="d-flex justify-content-center img-container">
                      <img
                        src="./res/figures/wireless-adicionar-alterar.png"
                        className="card-img-bottom img-xl"
                        alt=""
                      />
                    </div>

                    <p className="mb-0 justified-text">
                      <strong>Nome da Rede (SSID): </strong>Identificação da
                      rede Wireless.
                    </p>
                    <p className="mb-0 justified-text">
                      <strong>Caracteres suportados: </strong>{" "}
                      {specialCharacters}
                    </p>

                    <p className="mb-0 justified-text">
                      <strong>Tipo de autenticação: </strong>
                    </p>

                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Sistema Aberto: </strong>Autenticação
                          desabilitada.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>WPA: </strong>Tipo de autenticação baseado em
                          IEEE 802.11, utilizando criptografia AES ou TKIP/AES
                          (requer servidor RADIUS).
                        </p>
                        <ul className="p-xss-0 p-md-3 justified-text pt-0">
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Senha: </strong>Senha do servidor RADIUS.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Criptografia: </strong>AES ou TKIP/AES.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>NAS ID: </strong>ID de identificação para
                              o servidor Radius.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Porta: </strong>Porta do servidor RADIUS.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Server address: </strong>Endereço do
                              servidor RADIUS.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>WPA2: </strong>Tipo de autenticação baseado em
                          IEEE 802.11, utilizando criptografia AES ou TKIP/AES
                          (requer servidor RADIUS).
                        </p>
                        <ul className="p-xss-0 p-md-3 justified-text pt-0">
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Senha: </strong>Senha do servidor RADIUS.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Criptografia: </strong>AES ou TKIP/AES.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>NAS ID: </strong>ID de identificação para
                              o servidor Radius.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Porta: </strong>Porta do servidor RADIUS.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Server address: </strong>Endereço do
                              servidor RADIUS.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>WPA-PSK: </strong>Chave pessoal compartilhada,
                          utilizando criptografia AES ou TKIP/AES.
                        </p>
                        <ul className="p-xss-0 p-md-3 justified-text pt-0">
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Criptografia: </strong>AES ou TKIP/AES.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Senha: </strong>Senha (no mínimo 8
                              caracteres).
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>WPA2-PSK: </strong>Chave pessoal
                          compartilhada, utilizando criptografia AES ou
                          TKIP/AES.
                        </p>
                        <ul className="p-xss-0 p-md-3 justified-text pt-0">
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Criptografia: </strong>AES ou TKIP/AES.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Senha: </strong>Senha (no mínimo 8
                              caracteres).
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Dual Band: </strong>Permite definir o
                          comportamento da rede, se funcionará em modo dual band
                          (2.4 GHz e 5 GHz) ou single band (2.4 GHz ou 5 GHz).
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Configuração avançada: </strong>
                        </p>
                        <ul className="p-xss-0 p-md-3 justified-text pt-0">
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Isolar SSID: </strong>Bloqueia a
                              comunicação entre os equipamentos conectados em
                              diferentes SSID.
                            </p>
                          </li>
                          <li className="mb-4">
                            <div className="justified-text">
                              <p className="mb-3">
                                <strong>Somente internet:</strong>
                              </p>

                              <p className="mb-3">
                                Cenário para entendimento das regras da opção
                                <strong> “Somente internet”</strong>:
                              </p>

                              <div className="card shadow-sm border-0 rounded-4 overflow-hidden mb-3">
                                <img
                                  src="./res/figures/somente-internet.png"
                                  className="card-img-top img-fluid w-50 mx-auto d-block"
                                  alt="Cenário da opção Somente internet"
                                />
                              </div>

                              <p className="mb-3">
                                No cenário acima, a opção <strong>“Somente internet”</strong> foi
                                ativada para o <strong>“SSID 01 (2.4GHz)”</strong>.
                              </p>

                              <p className="mb-2">
                                Neste cenário, explicaremos como a configuração
                                <strong> “Somente internet”</strong> define a comunicação do
                                <strong> “Cliente 02”</strong>, conectado no
                                <strong> “SSID 01 (2.4GHz)”</strong>, nas seguintes perspectivas:
                              </p>

                              <ol className="ps-3 mb-0">
                                <li className="mb-1">
                                  Se ele comunica com o <strong>“Host 01”</strong>;
                                </li>

                                <li className="mb-1">
                                  Se ele comunica com clientes de outros SSIDs do mesmo AP —
                                  <strong> “Cliente 04”</strong>;
                                </li>

                                <li className="mb-1">
                                  Se ele comunica com clientes do mesmo SSID, mas em frequência
                                  diferente — <strong>“Cliente 01”</strong>;
                                </li>

                                <li className="mb-1">
                                  Se ele comunica com clientes do mesmo SSID e mesma frequência —
                                  <strong> “Cliente 03”</strong>;
                                </li>

                                <li className="mb-1">
                                  Se ele acessa a interface de gerência do
                                  <strong> “Dispositivo Intelbras”</strong>;
                                </li>

                                <li>
                                  Se ele comunica com a Internet.
                                </li>
                              </ol>
                              <table className="table">
                                <thead className="thead-dark">
                                  <tr>
                                    <th style={{ textAlign: "center" }} scope="col">#</th>
                                    <th style={{ textAlign: "center" }} scope="col" className="text-center">
                                      Comunicação com...
                                    </th>
                                    <th style={{ textAlign: "center" }} scope="col">Bridge / Router</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr style={{ textAlign: "center" }}>
                                    <td>1</td>
                                    <td>Host 01</td>
                                    <td>Não</td>
                                  </tr>
                                  <tr style={{ textAlign: "center" }}>
                                    <td>2</td>
                                    <td>Cliente 04</td>
                                    <td>Não</td>
                                  </tr>
                                  <tr style={{ textAlign: "center" }}>
                                    <td>3</td>
                                    <td>Cliente 01</td>
                                    <td>Não</td>
                                  </tr>
                                  <tr style={{ textAlign: "center" }}>
                                    <td>4</td>
                                    <td>Cliente 03</td>
                                    <td>Sim</td>
                                  </tr>
                                  <tr style={{ textAlign: "center" }}>
                                    <td>5</td>
                                    <td>Interface de gerência do dispositivo Intelbras</td>
                                    <td>Sim</td>
                                  </tr>
                                  <tr style={{ textAlign: "center" }}>
                                    <td>6</td>
                                    <td>Internet</td>
                                    <td>Sim</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Ocultar SSID: </strong>Permite ocultar a
                              rede sem fio. A opção "Ocultar SSID" fica bloqueada
                              quando o Smart Handover estiver ativo
                              (Wireless - Wireless avançado).
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Isolar clientes: </strong>Bloqueia a
                              comunicação entre os equipamentos conectados neste
                              SSID.
                            </p>
                          </li>
                          <li>
                            <p className="justified-text">
                              <strong>VLAN: </strong>Selecione para habilitar e
                              definir a VLAN.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>
                                ACL - Modo do controle de acesso:{" "}
                              </strong>
                            </p>
                            <ul className="p-xss-0 p-md-3 justified-text pt-0">
                              <li>
                                <p className="mb-0 justified-text">
                                  <strong>Desativado: </strong>ACL desativado.
                                </p>
                              </li>
                              <li>
                                <p className="mb-0 justified-text">
                                  <strong>Permitir listados: </strong>Permite a
                                  conexão de clientes definidos na lista de
                                  clientes.
                                </p>
                              </li>
                              <li>
                                <p className="mb-0 justified-text">
                                  <strong>Bloquear listados: </strong>Bloqueia a
                                  conexão dos equipamentos adicionados na lista
                                  de clientes.
                                </p>
                              </li>
                              <li>
                                <p className="mb-0 justified-text">
                                  Quando ativado, clique em{" "}
                                  <i
                                    className="fa fa-plus-circle"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Adicionar para incluir clientes na lista.
                                </p>
                              </li>

                              <li>
                                <p className="mb-0 justified-text">
                                  <strong>
                                    Quantidade máxima de registros:
                                  </strong>{" "}
                                  64
                                </p>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Máximo de clientes conectados: </strong>
                              Selecione um valor para definir a quantidade de
                              clientes conectados no mesmo SSID.
                            </p>
                            <p className="mb-0 justified-text">
                              <strong>Obs.: </strong>Verifique na ficha técnica
                              do produto a quantidade máxima de clientes
                              suportados.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>
                                Mínimo de sinal do cliente (dBm):{" "}
                              </strong>
                              Permite configurar o valor mínimo de sinal
                              aceitável de cada cliente conectado. A opção
                              "Mínimo de sinal do cliente (dBm)" fica bloqueada quando
                              o Smart Handover estiver ativo (Wireless - Wireless avançado).
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div>
                <div id="wireless-acl" className="fw-bold">
                  Wireless ACL
                </div>
                <p className="justified-text">
                  Permite centralizar as configurações de ACL sem a necessidade
                  de repetir as regras nos SSIDs do produto.
                </p>

                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/wireless-acl.png"
                    className="card-img-bottom img-fluid w-75 mx-auto d-block"
                    alt=""
                  />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Lista de SSIDs - Modo de controle de acesso: </strong>permite selecionar
                          o modo de controle de acesso - "Permitir" ou "Bloquear" -
                          para o SSID especificado. A opção "Desabilitado" desativa as regras.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Descrição: </strong>descrição para identificar
                          a regra cadastrada.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>MAC: </strong>endereço MAC do cliente wireless
                          que deverá respeitar a regra cadastrada.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>SSID: </strong>permite selecionar os SSIDs
                          cadastrados no produto.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Lista de controle de acesso: </strong>contém as regras cadastradas.
                        É possível efetuar edição nas regras.
                    </p>
                  </li>
                </ul>
              </div>

              <div>
                <div id="wireless-avancado" className="fw-bold">
                  Wireless avançado
                </div>
                <p className="justified-text">
                  Permite definir configurações e funcionalidades extras da
                  interface Wireless.
                </p>

                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/wireless-avancado.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Wireless Roaming: </strong>permite que os clientes
                      conectados transitem de um AP para o outro de forma
                      transparente e sem perda de pacotes.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Habilitar Assisted Roaming: </strong>suporte aos
                      protocolos 802.11k e 802.11v. Marque para habilitar a
                      função em seu equipamento. Com a função habilitada, o AP
                      irá sugerir a transição para os equipamentos quando for
                      conveniente.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Habilitar Fast Roaming: </strong>suporte ao
                      protocolo 802.11r. Marque para habilitar a função em seu
                      equipamento. Opera somente em SSIDs com criptografia WPA
                      ou WPA2 e requer que o equipamento do cliente tenha
                      suporte a este protocolo.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Smart Handover: </strong>marque para habilitar a
                      função Smart Handover no seu equipamento. Com a função
                      habilitada, o AP irá gerenciar a transição dos
                      equipamentos de forma ativa, com base nas métricas de rede
                      e qualidade do sinal.  Por esta razão, as configurações de
                      Wi-Fi "Mínimo de sinal do cliente" e "Ocultar SSID" serão
                      desabilitadas quando o Smart Handover estiver ativo.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Definir este AP como principal: </strong>marque
                      para definir este AP como principal. Os demais APs deverão
                      estar desmarcados e com o mesmo SSID do AP Principal, para
                      correto funcionamento.
                    </p>
                    <p className="mb-0 justified-text">
                      <strong>Atenção: </strong>a funcionalidade Smart Handover
                      é recomendada para redes de pequeno porte, com no máximo 6
                      roteadores empresariais e 100 equipamentos. Para redes de maior porte,
                      utilize a função Assisted Roaming.
                      O Smart Handover não está disponível para os produtos AX.
                    </p>
                    <p className="mb-0 justified-text">
                      <strong>Obs.: </strong>esta funcionalidade está disponível
                      apenas em Modo de operação Bridge. Verificar na ficha
                      técnica do produto a disponibilidade da função.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Band Steering: </strong>o Band Steering é uma
                      técnica utilizada em ambientes Wi-Fi dual-band que
                      estimula os equipamentos clientes a se conectarem na banda
                      de 5 GHz para que haja máximo desempenho decorrente da
                      maior capacidade dessa banda, porém a decisão final acerca
                      de qual banda utilizar depende inteiramente do próprio
                      cliente.
                    </p>
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <p className="mb-0">Métodos:</p>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Preferencialmente 5 GHz: </strong>realiza a
                          priorização da conexão na rede 5 GHz independente da
                          performance. Se após a conexão, a rede 5 GHz estiver
                          muito degradada (interferência, performance baixa ou
                          muitos clientes conectados consumindo recursos), o
                          usuário será direcionado para a rede 2,4 GHz, pois
                          terá a melhor performance considerada no momento. Se
                          durante o período de conexão deste cliente a rede 5
                          GHz melhorar a sua performance, o usuário será
                          redirecionado automaticamente para a rede 5 GHz sem
                          perda na conexão.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>
                            Balanceamento de clientes entre frequências:{" "}
                          </strong>
                          realiza a priorização da conexão baseada na melhor
                          frequência para o usuário. Normalmente a melhor
                          frequência para equipamentos dual band é a de 5GHz.
                          Porém, caso a rede 5 GHz esteja muito degradada
                          (interferência, performance baixa ou muitos clientes
                          conectados consumindo recursos), na conexão, o usuário
                          será direcionado diretamente para a rede 2,4 GHz pois
                          terá a melhor performance considerada no momento. Se
                          durante o período de conexão deste cliente a rede 5
                          GHz melhorar a sua performance, o usuário será
                          redirecionado automaticamente para a rede 5 GHz sem
                          perda na conexão.
                        </p>
                        <p className="mb-0 justified-text">
                          <strong>Importante: </strong>é muito comum o
                          Balanceamento de clientes entre as frequências falhar
                          por causa da característica de maior alcance do sinal
                          na banda 2,4 GHz, por isso, é muito importante ajustar
                          corretamente a potência do rádio 2,4 GHz, para que
                          ambas as frequências (2,4 GHz e 5 GHz) tenham a mesma
                          potência na prática.
                        </p>
                      </li>
                      <p className="mb-0 justified-text">
                        <strong>Obs.: </strong>a função de Band Steering está
                        disponível apenas para os modelos AP Dual-Band.
                      </p>
                    </ul>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Beamforming: </strong>o Beamforming garante que o
                      sinal de Wi-Fi seja direcionado diretamente aos
                      equipamentos dos clientes, evitando perdas durante o
                      processo de transmissão e melhorando o nível de sinal na
                      área de 360° ao redor do AP. Marque para habilitar a
                      função em seu equipamento.
                    </p>
                  </li>
                  {/* <li>
      <p className="mb-0 justified-text">
        <strong>Multi-User MiMo: </strong>o MU-MIMO garante maior performance aos clientes conectados na rede, realizando múltiplas transmissões de dados para clientes simultaneamente. Marque para habilitar a função em seu equipamento.
      </p>
      <p className="mb-0 justified-text">
        <strong>Obs.: </strong>a função MU-MIMO está disponível apenas para o modelo AP 5400 AX.
      </p>
    </li> */}
                </ul>
              </div>

              <div>
                <div id="wireless-radio-2_4ghz" className="fw-bold">
                  Wireless | Radio 2.4 GHz
                </div>

                <p className="justified-text">
                  Permite definir o comportamento do equipamento nas redes sem
                  fio de 2.4 GHz.
                </p>

                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/wireless-2_4ghz.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Ativar 2.4 GHz: </strong>ativa o funcionamento do
                      equipamento na frequência de 2.4 GHz.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Modo de Operação: </strong>modo de operação do
                      equipamento.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Modo IEEE: </strong>define o padrão de comunicação
                      da rede Wireless.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>País: </strong>o país a ser exibido será Brasil.
                    </p>
                  </li>
                  <WirelessAccessPointsLink />
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Site survey: </strong>realiza o escaneamento e a
                      listagem e exibição das informações sobre redes sem fio
                      (SSIDs) 2.4 GHz próximas ao dispositivo.
                    </p>
                  </li>



                  <div className="d-flex justify-content-center">
                    <img
                      src="./res/figures/wireless-2_4ghz-site-survey.png"
                      className="card-img-bottom img-xl"
                      alt=""
                    />
                  </div>

                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Canal: </strong>canal utilizado pelo equipamento.
                    </p>
                    <p className="mb-0 justified-text" id="ssid-config">
                      O botão "Selecionar banda e canal" permite selecionar o
                      canal e a largura de banda:
                    </p>
                  </li>

                  <div className="d-flex justify-content-center">
                    <img
                      src="./res/figures/largura-banda-canal-2_4ghz.png"
                      className="card-img-bottom img-xl"
                      alt=""
                    />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Largura de banda: </strong>o padrão é de 20 MHz
                        para equipamentos baseados no padrão 802.11. Entretanto,
                        os padrões 802.11n, 802.11ac e 802.11ax permitem a
                        junção de canais, aumentando assim a taxa de
                        transferência de dados.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>
                          Preferencialmente a largura selecionada:{" "}
                        </strong>
                        indica ao AP a preferência em operar na largura
                        selecionada manualmente.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Canal de extensão: </strong>se o padrão for{" "}
                        <i>b/g/n/ax</i> e a largura de banda 40 MHz, isto define
                        se o segundo canal vai ser acima ou abaixo do canal
                        central.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Seleção de canal: </strong>selecione um canal de
                        preferência. Ao selecionar mais que um canal ou nenhum,
                        a função Canal automático será ativada.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Potência de Transmissão (dBm): </strong>permite
                        especificar manualmente a potência de transmissão.
                      </p>
                    </li>
                  </ul>
                </ul>
              </div>

              <div>
                <p className="mb-0">
                  <strong id="wireless-radio-5ghz">
                    Wireless | Radio 5 GHz
                  </strong>
                </p>
                <p className="justified-text">
                  Permite definir o comportamento do equipamento nas redes sem
                  fio de 5 GHz.
                </p>

                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/wireless-5ghz.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Ativar 5 GHz: </strong>ativa o funcionamento do
                      equipamento na frequência de 5 GHz.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Modo de Operação: </strong>modo de operação do
                      equipamento.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Modo IEEE: </strong>define o padrão de comunicação
                      da rede Wireless.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>País: </strong>o país a ser exibido será Brasil.
                    </p>
                  </li>
                  <WirelessAccessPointsLink />
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Site survey: </strong>realiza o escaneamento e a
                      listagem e exibição das informações sobre redes sem fio
                      (SSIDs) 5 GHz próximas ao dispositivo.
                    </p>
                  </li>

                  <div className="d-flex justify-content-center">
                    <img
                      src="./res/figures/wireless-5ghz-site-survey.png"
                      className="card-img-bottom img-xl"
                      alt=""
                    />
                  </div>

                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Canal: </strong>canal utilizado pelo equipamento.
                    </p>
                    <p className="mb-0 justified-text">
                      O botão "Selecionar banda e canal" permite selecionar o
                      canal e a largura de banda:
                    </p>
                  </li>

                  <div className="d-flex justify-content-center">
                    <img
                      src="./res/figures/largura-banda-canal-5ghz.png"
                      className="card-img-bottom img-xl"
                      alt=""
                    />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Largura de banda: </strong>o padrão é de 20 MHz
                        para equipamentos baseados no padrão 802.11. Entretanto,
                        os padrões 802.11n, 802.11ac e 802.11ax permitem a
                        junção de canais, aumentando assim a taxa de
                        transferência de dados.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>
                          Preferencialmente a largura selecionada:{" "}
                        </strong>
                        indica ao AP a preferência em operar na largura
                        selecionada manualmente.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Canal de extensão: </strong>se o padrão for{" "}
                        <i>a/n/ac/ax</i> e a largura de banda 80 MHz, isto
                        define se o segundo canal vai ser acima ou abaixo do
                        canal central.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Seleção de canal: </strong>selecione um canal de
                        preferência. Ao selecionar mais que um canal ou nenhum,
                        a função Canal automático será ativada.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Potência de Transmissão (dBm): </strong>permite
                        especificar manualmente a potência de transmissão.
                      </p>
                    </li>
                  </ul>
                </ul>

                <ul>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>
                        Regra de exibição de autenticação AES/TKIP:
                      </strong>
                    </p>
                    <div className="table-container">
                      <table className="table">
                        <thead className="thead-dark">
                          <tr>
                            <th scope="col">Wireless</th>
                            <th scope="col" className="text-center">
                              Modos suportados (supported_phy_modes)
                            </th>
                            <th scope="col">Modo IEEE</th>
                            <th scope="col">Largura de Banda Suportada</th>
                            <th scope="col">Criptografia Suportada</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style={{ textAlign: "center" }}>
                            <th scope="row" rowSpan="3">
                              2.4 GHz
                            </th>
                            <td>3</td>
                            <td>b/g</td>
                            <td>20 MHz</td>
                            <td>AES, TKIP/AES</td>
                          </tr>
                          <tr style={{ textAlign: "center" }}>
                            <td>11</td>
                            <td>b/g/n</td>
                            <td>20/40 MHz</td>
                            <td>AES</td>
                          </tr>
                          <tr style={{ textAlign: "center" }}>
                            <td>43</td>
                            <td>b/g/n/AX</td>
                            <td>20/40 MHz</td>
                            <td>AES</td>
                          </tr>
                          <tr style={{ textAlign: "center" }}>
                            <th scope="row" rowSpan="4">
                              5 GHz
                            </th>
                            <td>4</td>
                            <td>a</td>
                            <td>20 MHz</td>
                            <td>AES, TKIP/AES</td>
                          </tr>
                          <tr style={{ textAlign: "center" }}>
                            <td>12</td>
                            <td>a/n</td>
                            <td>20/40 MHz</td>
                            <td>AES</td>
                          </tr>
                          <tr style={{ textAlign: "center" }}>
                            <td>28</td>
                            <td>a/n/ac</td>
                            <td>20/40/80 MHz</td>
                            <td>AES</td>
                          </tr>
                          <tr style={{ textAlign: "center" }}>
                            <td>60</td>
                            <td>a/n/ac/ax</td>
                            <td>20/40/80/160 MHz</td>
                            <td>AES</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </li>
                </ul>
              </div>

              <div>
                <p className="mb-0">
                  <strong id="site-survey">Site survey</strong>
                </p>
                <p className="justified-text">
                  Realiza o escaneamento e a listagem e exibição das informações
                  sobre redes sem fio (SSIDs) próximas ao dispositivo.
                </p>

                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/site-survey.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      O Site Survey pode ser feito dentro das configurações de
                      Wireless rádio ("Radio 5GHz" e "Rádio 2.4GHz"), tendo as
                      informações das redes exibidas de acordo com a
                      configuração do rádio que o usuário se encontra. Ou pode
                      ser feito também no submenu próprio onde o usuário pode
                      selecionar se deseja listar as informações das redes 5GHz
                      ou 2.4GHz.
                    </p>
                  </li>
                </ul>
              </div>

              <div>
                <p className="mb-0">
                  <strong id="radius">Radius</strong>
                </p>
                <p className="justified-text">
                  Permite configurar servidores Radius no equipamento.
                </p>

                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/radius.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>NAS ID: </strong>ID de identificação para o
                      servidor Radius.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Descrição: </strong>descrição do servidor RADIUS.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Endereço Servidor: </strong>endereço do servidor
                      RADIUS.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Senha: </strong>senha do servidor RADIUS.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Porta Autenticação: </strong>porta do servidor
                      RADIUS.
                    </p>
                  </li>
                </ul>
              </div>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Network;
